import type { VolunteerDropdownData } from '#/components/VolunteerDropdown/types/VolunteerDropdownData';
import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetVolopsRoutePath } from '#/modules/search/volops/routing/searchGetVolopsRoutePath';
import { postAListingRoute } from '#/routing/routes';

export const volunteerDropdownDataEs: VolunteerDropdownData = {
  search: {
    title: 'Voluntariado',
    items: [
      {
        type: 'volop',
        title: 'Encontrar Voluntariado',
        href: searchGetVolopsRoutePath({
          locale: I18nLocale.ES,
          embedSearchWidgetId: null,
        }),
      },
      {
        type: 'post-a-listing',
        title: 'Publicar Voluntariado',
        href: postAListingRoute.with({}),
      },
    ],
  },
  resources: {
    title: 'Recursos',
    items: [
      {
        type: 'blog',
        title: 'Blog Idealistas / Voluntariado',
        description:
          'Consejos, recursos para personas voluntarias y gestión de voluntariado en organizaciones.',
        href: '/es/accion?categories=voluntariado&pq=',
      },
    ],
  },
};
